export default {
  install: (app, options)=>{
    let vue = new app()
    // vue.provide('i18n',options)
    app._myplugin = function(key){
      console.log('myPlugin',key)
      return 11111
    }
    // console.log('myPlugin',vue,app,options)
  }
}
